import { Link, useLocation } from "react-router-dom";
import { menuItems } from "../../sideNavbar/menuItem";
import './sidebar.scss'

const Sidebar = ({ isOpen }) => {
  const location = useLocation();

  return (
    <aside
      className={`border-end position-fixed start-0 h-100 p-3 shadow-sm transition ${
        isOpen ? "d-block" : "d-none"
      } d-lg-block`}
      style={{
        width: "290px",
        zIndex: 1050,
        borderTop: "2px solid #0aa5a2",
        ...(isOpen ? {} : { top: "69px" }),
        background: "rgba(0, 165, 162, 0.9)",
      }}
    >
      <nav>
        <ul className="nav flex-column">
          {menuItems?.map((item, index) => {
            const isActive = location.pathname === item.path;
   
            return (
              <li className="nav-item mb-2" key={index}>
                <Link
                  to={item.path}
                  className={`nav-link d-flex align-items-center gap-2 ${
                    isActive ? "active text-white fw-bold" : "text-light"
                  }`}
                >
                  {item.icon}
                  {item.linkText}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </aside>
  );
};

export default Sidebar;
